import styled from 'styled-components'

export const RankingComponents = styled.div`
  height: 53vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #303746;
  h1 {
    font-size: 30px;
    font-weight: bold;
    margin: 50px;
  }
  img {
    z-index: -999;
  }
`

export const RankingDetails = styled.div`
  background-color: #fff;
  width: 100%;
  border-radius: 50px;
  padding-bottom: 10px;
`
